import { useNavigate } from "react-router";
import Button from "./Button";
import { useLanguageContext } from "@/hooks";

export default function GoBackButton(props){
    const navigate  = useNavigate()
    const { language } = useLanguageContext();

    
    return <Button {...props} primary rounded outline onClick={() => navigate(-1)}><i className="bi bi-arrow-left me-1"></i>{language('label.back')}</Button>
}